import { createContext, useState } from "react";
import * as THREE from "three";
//
//
const ColorsChairContext = createContext();

export function ChairColorsProvider({ children }) {
  const orange = new THREE.Color(0xffffff);
  // colors from cushion
  const burntSienna = new THREE.Color(0xdd7f1a);
  const oliveGreen = new THREE.Color(0xffffff);
  const mossGreen = new THREE.Color(0x808a4b);
  const [currentColor, setCurrentColor] = useState(orange);
  //

  const colorFontWhite1 = "#fefefe";
  const [currentsColorFont, setCurrentColorFont] = useState(colorFontWhite1);
  const colorFontWhite2 = "#141414";
  const [currentsColorFont2, setCurrentColorFont2] = useState(colorFontWhite2);

  const color0 = "#141414"; // ** charbon
  const colorA = "#e5edf4"; // ** blue ciel
  const colorB = "#FDFAF3"; // ** bone
  const colorC = "#e5edf4"; // ** blue ciel
  const [currentsColorBg, setCurrentColorBg] = useState(color0);
  //
  const handleColorChange = (event, color) => {
    event.preventDefault();
    if (color === "burntSienna") {
      setCurrentColor(burntSienna);
    } else if (color === "oliveGreen") {
      setCurrentColor(oliveGreen);
    } else if (color === "mossGreen") {
      setCurrentColor(mossGreen);
    } else {
      setCurrentColor(orange);
    }
  };
  //

  const grey = new THREE.Color(0xcccccc);
  const blackLeather = new THREE.Color(0x101010);
  const burntSiennaMediumDark = new THREE.Color(0x361609);
  const greenMediumDark = new THREE.Color(0x303030);

  const [currentCrocoColor, setCurrentCroco] = useState(burntSiennaMediumDark);

  const handleColorCrocoChair = (event, colorCroco) => {
    event.preventDefault();
    if (colorCroco === "blackLeather") {
      setCurrentCroco(blackLeather);
    } else if (colorCroco === "burntSiennaMediumDark") {
      setCurrentCroco(burntSiennaMediumDark);
    } else if (colorCroco === "greenMediumDark") {
      setCurrentCroco(greenMediumDark);
    } else {
      setCurrentCroco(grey);
    }
  };
  return (
    <ColorsChairContext.Provider
      value={{
        grey,
        blackLeather,
        burntSiennaMediumDark,
        greenMediumDark,
        currentCrocoColor,
        setCurrentCroco,
        handleColorCrocoChair,

        currentsColorBg,
        currentsColorFont,
        setCurrentColorFont,
        currentsColorFont2,
        //
        currentColor,
        handleColorChange,
        setCurrentColor,
        setCurrentColorBg,
      }}
    >
      {children}
    </ColorsChairContext.Provider>
  );
}
export default ColorsChairContext;
